import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { SharingService } from '../../../shared/shared.service';
import { SaveFormDeclaration } from '../../models/SaveFormDeclaration';
import { Activity1, Activity2, Activity3, Activity4, Activity5 } from '../../models/Activities';
import { DeclarationService } from '../../services/forms.service';
import { DecimalPipe, CurrencyPipe, formatDate, DatePipe } from '@angular/common';

// import { SaveFormDeclarationLocalData } from '../../../dashboard/saveDeclarationdata';
import { CustomSpinnerComponent } from '../../../../shared/components/custom-spinner/custom-spinner.component';
import { NumberFormatPipe } from '../../../../shared/number.pipe';


declare var require: any;
@Component({
  selector: 'app-form2',
  templateUrl: './form2.component.html',
  styleUrls: ['./form2.component.css']
})
export class Form2Component implements OnInit {
  customSpinnerComponent = CustomSpinnerComponent;
  Form2: FormGroup;
  formSubmitted = false;
  userNum: number;
  public activity1Model: Activity1;
  public activity2Model: Activity2;
  public activity3Model: Activity3;
  public activity4Model: Activity4;
  public activity5Model: Activity5;
  declarationList = [];
  // saveFormDeclarationLocalData: SaveFormDeclarationLocalData;
  dNET: any; dTVA: any;
  a1NET: number; a1TVA: number; a2NET: number; a2TVA: number; a3NET: number; a3TVA: number; a4NET: number; a5NET: number;
  remarks: any;
  isDataEntered: boolean;
  percent1: number; percent2: number; percent3: number; percent4: number; percent5: number;
  Total: number = 0;
  msgMaxPercentageError: boolean = false;
  capacity: any;
  totalPercentage: number;
  msgErrorPercent: boolean = false;
  saveFormDeclarationModel: SaveFormDeclaration;
  sumOfActivityNetAmt: number;
  msgErrorNET: boolean = false;
  msgErrorFieldMissing: boolean = false;
  form2Data: any;
  clientsData: any;
  clicked = false;
  Declaration2Data: any;
  Year: any;
  selectedDeclarationNo : number;
  activitiesData: any = [];
  activitiesCollection = [];
  isActivity4Present: boolean;
  isActivity5Present: boolean;
  isActivity1Present: boolean;
  isActivity2Present: boolean;
  isActivity3Present: boolean;
  IsTVAWarningMsgEnable: boolean = false;
  msgErrorNotSaved: boolean = false;
  headerData: any[];
  today = new Date();
  jstoday = '';
  // declaration: Declaration;
  dataXML: any;
  xmlFile: any;
  declaration: any;
  declaration2Data = {
    FormType: "",
    FormSubType: "",
    ContractNummer: "",
    AccountNumber: "",
    User: 0,
    dataXML: {
      XMLFile: {
        Header:
        {
          QualCiv: "",
          Nom: "",
          Prenom: "",
          NoClient: 0,
          RegimeLinguistique: 0,
          Email: "",
          Rue: "",
          NoRue: "",
          CodePostal: 0,
          Localite: "",
          LibellePays: ""
        },
        Declaration: [
          {
            Comment: "",
            contrat: [],
            Exercice: 0,
            PeriodeDebut: '',
            PeriodeFin: '',
            NoDeclaration: 0,
            NoProgressif: 0,
            Genre: "I",

            noIntervenantDestinataire: 0,
            NomDestinataire: "",
            PrenomDestinataire: "",
            RoleDestinataire: "",
            Statut: "",
            Libelle: "",
            CodeMontantBrut: "",
            MontantBrut: 0,
            CodeMontantNet: '',
            MontantNet: 0,
            CodeMontantTVA: '',
            MontantTVA: 0,
            TVAApplicable: 1,
            CodeActivite: "",
            Activite: [
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
            ],
            LastModifiedDate: "",
            CodePourcentTot: 0,
            independant: [

            ]
          }
        ]
      }
    }
  }
  savedForm2Data: any;
  isPercentageCheckRequired: boolean = true;
  SavedData: any;
  FormsData: any = [];
  oldAmtVal:any;
isActive:boolean;
  constructor(private _router: Router, private service: DeclarationService,
    private formBuilder: FormBuilder, private pipe: DatePipe, public sharingService: SharingService,
    private formatPipe: NumberFormatPipe) {
    this.activity1Model = new Activity1();
    this.activity2Model = new Activity2();
    this.activity3Model = new Activity3();
    this.activity4Model = new Activity4();
    this.activity5Model = new Activity5();

  }
  

 

  formatOnFocusIn(s){
    this.isActive = true;
    if(s.target.value === '0' || s.target.value === '0,00'){
      s.target.value = '';
    }   

    s.target.value =  s.target.value.replace(/\./g, '');   
    s.target.value =  s.target.value.replace(/\,/g, '.');
    
    
    const commaIndex = s.target.value.indexOf(',');
    if(commaIndex >- 1){ 
    s.target.value = this.replaceAt(s.target.value,commaIndex,'.');
    }
    // const dotIndex =  s.target.value.indexOf('.');
    // if(dotIndex > -1){
    //   s.target.value  = s.target.value ;
    // }
  }

  validateOperator(s){
    var t = s.target.value;  
   
    
    if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46 || s.keyCode === 188 || s.keyCode === 44){//comma
     if(t.match(/[,]/g) !== null){
      if(t.match(/[,]/g).length > 1){
        return false;
      } 
     }

     if(t.match(/[.]/g) !== null){  
      if(t.match(/[.]/g).length > 1){
        return false;
      } 
     }
     
      // if(t.match(/[,]/g).length > 1 || t.match(/[.]/g).length > 1){
      //   return false;
      // } 
    }
  }



  validateDecimal(s){
    var t = s.target.value; 
   
    let skipCharcode = [44,46,190]; //110  : Removed 110 for Bug :54601
    const charCode = s.which ? s.which : s.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) &&  skipCharcode.indexOf(charCode) === -1) {
      return false;
    }
    //this.numberandDecimal(s);
    //dot and comma
    if(t.match(/[.]/g) !== null){
      if( t.match(/[.]/g).length > 1 || (s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46)){
        return false;
      }
      
      if(s.keyCode === 44 || s.keyCode === 188){
        return false;
      }
    }
//comma and dot
    if(t.match(/[,]/g) !== null){
      if( t.match(/[,]/g).length > 1 || (s.keyCode === 44 || s.keyCode === 188)){
        return false;
      }
      
      if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46){
        return false;
      }
    }

    if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46){
      if(t.match(/[.]/g) !== null){
        if( t.match(/[.]/g).length > 1){
          return false;
        }
      }
     
    }
    else{
      if((t.indexOf(".") > -1)){
        //s.target.value = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 2)) : t;
        //s.target.value = t.split('.')[1].length < 2 ? t : t;
        if(t.split('.')[1].length < 2){
          s.target.value = t;
        }else{    
          return false;
        }
      }
      
      if((t.indexOf(",") > -1)){
        s.target.value = (t.indexOf(",") >= 0) ? 
        (t.substr(0, t.indexOf(",")) + t.substr(t.indexOf(","), 2)) :
        t;
      }
      
    }
     
    
  }

  clipboardPaste($event){
    console.log($event);
    const clipbaordData = $event.clipboardData.getData('Text');
    let s = {
      target: {
        value : clipbaordData
      }
    };

    let numericData = clipbaordData.replace(/[^0-9,.]/g, '');
   
//123,456,789=> 123456,789
//123.456.789=> 123456,789
let formatedData;
if(numericData.lastIndexOf(',') > -1){
  formatedData = numericData.substr(0,numericData.lastIndexOf(',')).replace(/\,/g,'').replace(/\./g,'') + numericData.slice(numericData.lastIndexOf(',')).replace(/\./g, '');
}else
if(numericData.lastIndexOf('.') > -1){
  formatedData = numericData.substr(0,numericData.lastIndexOf('.')).replace(/\./g,'').replace(/\,/g,'') + numericData.slice(numericData.lastIndexOf('.'));
}
  

s.target.value = formatedData;

$event.preventDefault();
 $event.target.value = formatedData.indexOf(',') > -1  ? formatedData : parseFloat(formatedData).toFixed(2);;

   

  }

 

  conversionDotToComma(val){
    if(typeof val === 'undefined' || val === null || val === 0)
    return val;

    //const dotIndex = val.toString().indexOf('.');    

    if(val.toString().match(/[.]/g) !== null){
      if(val.toString().match(/[.]/g).length > 1){
        return val;
      }
    }
    return this.formatPipe.transform(val);
  }

  conversionCommaToDot(val){
    if(typeof val === 'undefined' || val === null || val === 0)
    return val;

    if(val.toString().match(/[.]/g) !== null){
      if( val.toString().match(/[.]/g).length === 1){
        if(val.toString().indexOf(',') > -1){
          val =  val.toString().replace(/\./g, '');   
        }
      }else if(val.toString().match(/[.]/g).length > 1){
        val =  val.toString().replace(/\./g, '');   
      }
    }
    val =  val.toString().replace(/\,/g, '.');    
    
    const commaIndex = val.toString().indexOf(',');
    if(commaIndex >- 1){ 
      val = this.replaceAt(val,commaIndex,'.');
    }
    return Number(val);
  }

  formatOnFocusOut(s,modelname?){    
    if(s.target.value === ''){
      s.target.value = '0';
    }else{    
      
      const dotIndex = s.target.value.indexOf('.');    
      switch(modelname){
        case 'DTVA1':
          this.dTVA =  this.formatPipe.transform(s.target.value);
          break;
          case 'ACTIVITY1MODEL.NET':
            this.activity1Model.Net= this.formatPipe.transform(s.target.value);
            break;
            case 'ACTIVITY2MODEL.NET':
            this.activity2Model.Net= this.formatPipe.transform(s.target.value);
            break;
            case 'ACTIVITY3MODEL.NET':
            this.activity3Model.Net= this.formatPipe.transform(s.target.value);
            break;
            case 'ACTIVITY4MODEL.NET':
            this.activity4Model.Net= this.formatPipe.transform(s.target.value);
            break;
            case 'ACTIVITY5MODEL.NET':
            this.activity5Model.Net= this.formatPipe.transform(s.target.value);
          case 'ACTIVITY1PERCENT':
            this.activity1Model.Percentage = this.formatPipe.transform(s.target.value);
          break;
          case 'ACTIVITY2PERCENT':
            this.activity2Model.Percentage = this.formatPipe.transform(s.target.value);
          break;
          case 'ACTIVITY3PERCENT':
            this.activity3Model.Percentage = this.formatPipe.transform(s.target.value);
          break;
          case 'ACTIVITY4PERCENT':
            this.activity4Model.Percentage = this.formatPipe.transform(s.target.value);
          break;
          case 'ACTIVITY5PERCENT':
            this.activity5Model.Percentage = this.formatPipe.transform(s.target.value);
          break;
      }
      
      s.target.value = this.formatPipe.transform(s.target.value);
    }    
  }

  replaceAt = function(val,index, replacement) {
    if (index >= val.length) {
        return val.valueOf();
    } 
    return val.substring(0, index) + replacement + val.substring(index + 1);
}

formatUserNumber(t) {
  this.userNum = this.formatPipe.transform(t.target.value);
}

  realParseFloat(s)
{
    s = s.target.value.replace(/[^\d,.-]/g, ''); // strip everything except numbers, dots, commas and negative sign
    if (navigator.language.substring(0, 2) !== "de" && /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(s)) // if not in German locale and matches #,###.######
    {
        s = s.replace(/,/g, ''); // strip out commas
        return parseFloat(s); // convert to number
    }
    else if (/^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/.test(s)) // either in German locale or not match #,###.###### and now matches #.###,########
    {
        s = s.replace(/\./g, ''); // strip out dots
        s = s.replace(/,/g, '.'); // replace comma with dot
        return parseFloat(s);
    }
    else // try #,###.###### anyway
    {
        s = s.replace(/,/g, ''); // strip out commas
        return parseFloat(s); // convert to number
    }
}


onBlurMethod(val){
  console.log(val);
  val.target.value = new Intl.NumberFormat('de-DE').format(val.target.value);
  return true;
}

 

  ngOnInit(): void {
    
    // this.SaveFormDeclaration.dataXML.XMLFile.Declaration;
    this.Form2 = this.formBuilder.group({
      MNet: ['', [Validators.maxLength(9)]],
      MTva: ['', [Validators.required,Validators.maxLength(14)]],//,Validators.pattern('^[1-9][\.\d]*(,\d+)?$')
      activity1Net: ['', [Validators.required, Validators.maxLength(14),]],
      activity1Percent: ['', [Validators.required, Validators.maxLength(5)]],
      activity1Tva: ['', [Validators.maxLength(14)]],
      activity2Net: ['', [Validators.required, Validators.maxLength(14),]],
      activity2Percent: ['', [Validators.required, Validators.maxLength(5)]],
      activity2Tva: ['', [Validators.maxLength(14)]],
      activity3Net: ['', [Validators.required, Validators.maxLength(14),]],
      activity3Percent: ['', [Validators.required, Validators.maxLength(5)]],
      activity3Tva: ['', [Validators.maxLength(14)]],
      activity4Net: ['', [Validators.required, Validators.maxLength(14),]],
      activity4Percent: ['', [Validators.required, Validators.maxLength(5)]],
      activity4Tva: ['', Validators.maxLength(14)],
      activity5Net: ['', [Validators.required, Validators.maxLength(14),]],
      activity5Percent: ['', [Validators.required, Validators.maxLength(5)]],
      activity5Tva: ['', Validators.maxLength(14)],
      remarks: ['']
    });
    this.isDataEntered = false;
    //Get all the Forms data - 
    this.FormsData = JSON.parse(sessionStorage.getItem("FormsData"));
    let selectedForm = JSON.parse(sessionStorage.getItem("selectedFormData"));
    this.selectedDeclarationNo = selectedForm.NoDeclaration;

    //Get Saved Data from Cache -
    this.savedForm2Data = JSON.parse(sessionStorage.getItem("SavedDeclaration2CachedData"));

    // this.formGenreName = 
    if (sessionStorage.getItem('isForm2Saved') == 'true' && this.savedForm2Data !== null) {
      this.declaration2Data = this.savedForm2Data;
      this.dataXML = this.declaration2Data.dataXML;
      this.xmlFile = this.dataXML.XMLFile;
      var declaration = this.xmlFile.Declaration;
      declaration.forEach(element => {
        if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo) {
          this.savedForm2Data = element;
        }
      });

      this.savedForm2Data.Activite.forEach(element => {
        if (element !== null) {
          this.activitiesData.push(element);
        }
      });

      this.form2Data = this.savedForm2Data;
      this.dTVA = this.conversionDotToComma(this.form2Data.MontantNet);
      this.remarks = this.form2Data.Comment;

      if (!(this.dNET == 0 && this.form2Data.CodePourcentTot == 0)) {
        if (Number(this.form2Data.CodePourcentTot) == 100) {
          this.DisableNETControlls();
        }
        else
          this.DisablePercentageControlls();
      }
    }
    // Initial Load from Dashboard (Not saved data) -
    else {
      this.form2Data = JSON.parse(sessionStorage.getItem("selectedFormData"));
      var activitiesCollection = this.form2Data.Activite;
      if(activitiesCollection != null){
      activitiesCollection.forEach(element => {
        if (element != null && element.CodeActivite !== '' && element.Libelle !== '') {
          this.activitiesData.push(element);
        }
      });
    }
    
     this.dTVA = this.form2Data.MontantNet == "" || this.form2Data.MontantNet == '0' ? 0 : this.form2Data.MontantNet;// this.conversionDotToComma(this.form2Data.MontantNet);
     if(this.dTVA.toString().indexOf(',') === -1){
      // this.dTVA =  this.formatPipe.transform(this.dTVA);
      this.dTVA = this.dTVA;
     }
      this.remarks = this.form2Data.Comment;
      
      //Disable or Enable NET/Percentage boxes -
      if (!(Number(this.conversionCommaToDot(this.dTVA)) == 0 && Number(this.form2Data.CodePourcentTot) == 0)) {
        if (Number(this.form2Data.CodePourcentTot) == 100) {
          this.DisableNETControlls();
        }
        else
          this.DisablePercentageControlls();
      }
      else {
         this.EnablePercentageControlls();
         this.EnabledNETControlls();
      }
      sessionStorage.setItem('isForm2Saved', 'false');
    }

    //Get selected Clients data-
    this.clientsData = JSON.parse(sessionStorage.getItem("SelectedClientData"));

    if (this.activitiesData[0] !== undefined && this.activitiesData[0].CodeActivite != "") {
      this.isActivity1Present = true;
      this.activity1Model.ActivityNo = this.activitiesData[0].CodeActivite;
      this.activity1Model.Label = this.activitiesData[0].Libelle;
      this.activity1Model.Net = this.activitiesData[0].MontantNet == "" || this.activitiesData[0].MontantNet == '0' ? 0 : this.conversionDotToComma(this.activitiesData[0].MontantNet); //(this.activitiesData[0].MontantNet);
      this.activity1Model.Total = Number(this.activitiesData[0].MontantNet);
      this.activity1Model.Percentage = this.activitiesData[0].Pourcent == "" || this.activitiesData[0].Pourcent == '0' ? 0 : this.conversionCommaToDot(this.activitiesData[0].Pourcent);
      var s = { target : { value : this.activity1Model.Percentage.toString()}};
      this.formatOnFocusOut(s,'ACTIVITY1PERCENT');
    }
    else {
      this.isActivity1Present = false;
      this.activity1Model.Percentage = undefined;
    }

    if (this.activitiesData[1] !== undefined && this.activitiesData[1].CodeActivite != "") {
      this.isActivity2Present = true;
      this.activity2Model.ActivityNo = this.activitiesData[1].CodeActivite;
      this.activity2Model.Label = this.activitiesData[1].Libelle;
      this.activity2Model.Net = this.activitiesData[1].MontantNet == '' || this.activitiesData[1].MontantNet == '0' ? 0 :  this.conversionDotToComma(this.activitiesData[1].MontantNet); //this.activitiesData[1].MontantNet;
      this.activity2Model.Total = Number(this.activitiesData[1].MontantNet);
      this.activity2Model.Percentage = this.activitiesData[1].Pourcent == '' || this.activitiesData[1].Pourcent == '0' ? 0 : this.conversionCommaToDot(this.activitiesData[1].Pourcent);
      var s = { target : { value : this.activity2Model.Percentage.toString()}};
      this.formatOnFocusOut(s,'ACTIVITY2PERCENT');
    }
    else {
      this.isActivity2Present = false;
      this.activity2Model.Percentage = undefined;
    }

    if (this.activitiesData[2] !== undefined && this.activitiesData[2].CodeActivite != "") {
      this.isActivity3Present = true;
      this.activity3Model.ActivityNo = this.activitiesData[2].CodeActivite;
      this.activity3Model.Label = this.activitiesData[2].Libelle;
      this.activity3Model.Total = Number(this.activitiesData[2].MontantNet);
      this.activity3Model.Net = this.activitiesData[2].MontantNet == '' || this.activitiesData[2].MontantNet == '0' ? 0 : this.conversionDotToComma(this.activitiesData[2].MontantNet);
      this.activity3Model.Percentage = this.activitiesData[2].Pourcent == '' || this.activitiesData[2].Pourcent == '0' ? 0 : this.conversionCommaToDot(this.activitiesData[2].Pourcent);
      var s = { target : { value : this.activity3Model.Percentage.toString()}};
      this.formatOnFocusOut(s,'ACTIVITY3PERCENT');
    }
    else {
      this.isActivity3Present = false;
      this.activity3Model.Percentage = undefined;
    }
    if (this.activitiesData[3] !== undefined && this.activitiesData[3].CodeActivite != "") {
      this.isActivity4Present = true;
      this.activity4Model.ActivityNo = this.activitiesData[3].CodeActivite;
      this.activity4Model.Label = this.activitiesData[3].Libelle;
      this.activity4Model.Total = Number(this.activitiesData[3].MontantNet);
      this.activity4Model.Net = this.activitiesData[3].MontantNet == '' || this.activitiesData[3].MontantNet == '0' ? 0 : this.conversionDotToComma(this.activitiesData[3].MontantNet);
      this.activity4Model.Percentage = this.activitiesData[3].Pourcent == '' || this.activitiesData[3].Pourcent == '0' ? 0 : this.conversionCommaToDot(this.activitiesData[3].Pourcent);
      var s = { target : { value : this.activity4Model.Percentage.toString()}};
      this.formatOnFocusOut(s,'ACTIVITY4PERCENT');
    }
    else {
      this.isActivity4Present = false;
      this.activity4Model.Percentage = undefined;
    }
    if (this.activitiesData[4] !== undefined && this.activitiesData[4].CodeActivite != "") {
      this.isActivity5Present = true;
      this.activity5Model.ActivityNo = this.activitiesData[4].CodeActivite;
      this.activity5Model.Label = this.activitiesData[4].Libelle;
      this.activity5Model.Total = Number(this.activitiesData[4].MontantNet);
      this.activity5Model.Net = this.activitiesData[4].MontantNet == '' || this.activitiesData[4].MontantNet == '0' ? 0 : this.conversionDotToComma(this.activitiesData[4].MontantNet);
      this.activity5Model.Percentage = this.activitiesData[4].Pourcent == '' || this.activitiesData[4].Pourcent == '0' ? 0 : this.conversionCommaToDot(this.activitiesData[4].Pourcent);
      var s = { target : { value : this.activity5Model.Percentage.toString()}};
      this.formatOnFocusOut(s,'ACTIVITY5PERCENT');
    }
    else {
      this.isActivity5Present = false;
      this.activity5Model.Percentage = undefined;
    }



  }

  //Enable or Disable Control -
  DisableEnableControl(name: any, IsEnable: boolean): void {
    let ctrl = this.Form2.controls[name];
    IsEnable ? ctrl.enable() : ctrl.disable();
  }

  checkMaxNo(event: any) {
    if (this.conversionCommaToDot(this.dTVA)> 999999999) {
      event.preventDefault()
      this.dTVA = parseInt(this.dTVA.toString().substring(0, 9));
    }
    this.isDataEntered = true;
  }

  //Disable Percentage on NET TVA entered -
  disablePercent(event: any) {
    this.isDataEntered = true;
    // 1
    if (this.activity1Model.Net > 999999999) {
      event.preventDefault()
      this.activity1Model.Net = parseInt(this.activity1Model.Net.toString().substring(0, 9));
    }
    else{if (this.activity1Model.Net === 0 || this.activity1Model.Net === null || this.activity1Model.Net === undefined) {this.activity1Model.Net = 0;}}
    // 2
    if (this.activity2Model.Net > 999999999) {
      event.preventDefault()
      this.activity2Model.Net = parseInt(this.activity2Model.Net.toString().substring(0, 9));
    }
    else{if (this.activity2Model.Net === 0 || this.activity2Model.Net === null || this.activity2Model.Net === undefined) {this.activity2Model.Net = 0;}}
    // 3
    if (this.activity3Model.Net > 999999999) {
      event.preventDefault()
      this.activity3Model.Net = parseInt(this.activity3Model.Net.toString().substring(0, 9));
    }
    else{if (this.activity3Model.Net === 0 || this.activity3Model.Net === null || this.activity3Model.Net === undefined) {this.activity3Model.Net = 0;}}
    // 4
    if (this.activity4Model.Net > 999999999) {
      event.preventDefault()
      this.activity4Model.Net = parseInt(this.activity4Model.Net.toString().substring(0, 9));
    }
    else{if (this.activity4Model.Net === 0 || this.activity4Model.Net === null || this.activity4Model.Net === undefined) {this.activity4Model.Net = 0;}}
    // 5
    if (this.activity5Model.Net > 999999999) {
      event.preventDefault()
      this.activity5Model.Net = parseInt(this.activity5Model.Net.toString().substring(0, 9));
    }
    else{if (this.activity5Model.Net === 0 || this.activity5Model.Net === null || this.activity5Model.Net === undefined) {this.activity5Model.Net = 0;}}

    if (this.activity1Model.Net > 0 || this.activity2Model.Net > 0 || this.activity3Model.Net > 0 || this.activity4Model.Net > 0 || this.activity5Model.Net > 0) {
      this.isDataEntered = true;
      this.DisablePercentageControlls();
    }
    else if (this.activity1Model.Net == (0) && this.activity2Model.Net == (0) && this.activity3Model.Net == (0) && this.activity4Model.Net == (0) && this.activity5Model.Net == (0)) {
      this.EnablePercentageControlls();
    }
  }

  // Disable NET on Percentage entered -
  disableControl(event: any) {
    this.isDataEntered = true;
    if (this.activity1Model.Percentage > 100) {
      event.preventDefault()
      this.activity1Model.Percentage = parseInt(this.activity1Model.Percentage.toString().substring(0, 2));
    }
    else {if(this.activity1Model.Percentage == 0 || this.activity1Model.Percentage == null || this.activity1Model.Percentage == undefined) {this.activity1Model.Percentage = 0;}}
    if (this.activity2Model.Percentage > 100) {
      event.preventDefault()
      this.activity2Model.Percentage = parseInt(this.activity2Model.Percentage.toString().substring(0, 2));
    }
    else {if(this.activity2Model.Percentage == 0 || this.activity2Model.Percentage == null || this.activity2Model.Percentage == undefined) {this.activity2Model.Percentage = 0;}}
    if (this.activity3Model.Percentage > 100) {
      event.preventDefault()
      this.activity3Model.Percentage = parseInt(this.activity3Model.Percentage.toString().substring(0, 2));
    }
    else {if(this.activity3Model.Percentage == 0 || this.activity3Model.Percentage == null || this.activity3Model.Percentage == undefined) {this.activity3Model.Percentage = 0;}}
    if (this.activity4Model.Percentage > 100) {
      event.preventDefault()
      this.activity4Model.Percentage = parseInt(this.activity4Model.Percentage.toString().substring(0, 2));
    }
    else {if(this.activity4Model.Percentage == 0 || this.activity4Model.Percentage == null || this.activity4Model.Percentage == undefined) {this.activity4Model.Percentage = 0;}}
    if (this.activity5Model.Percentage > 100) {
      event.preventDefault()
      this.activity5Model.Percentage = parseInt(this.activity5Model.Percentage.toString().substring(0, 2));
    }
    else {if(this.activity5Model.Percentage == 0 || this.activity5Model.Percentage == null || this.activity5Model.Percentage == undefined) {this.activity5Model.Percentage = 0;}}

    if (this.activity1Model.Percentage > 0 || this.activity2Model.Percentage > 0 || this.activity3Model.Percentage > 0  || this.activity4Model.Percentage > 0 || this.activity5Model.Percentage > 0 ) {
      this.isDataEntered = true;
      this.DisableNETControlls();
    }
    else if (this.conversionCommaToDot(this.activity1Model.Percentage) == (0.00) && this.conversionCommaToDot(this.activity2Model.Percentage) == (0.00) && this.conversionCommaToDot(this.activity3Model.Percentage) == (0.00) && this.conversionCommaToDot(this.activity4Model.Percentage) == (0.00) && this.conversionCommaToDot(this.activity5Model.Percentage) == (0.00)) {
      this.EnabledNETControlls();
    }
  }

  EnabledNETControlls() {
    this.DisableEnableControl('activity1Net', true);
    this.DisableEnableControl('activity2Net', true);
    this.DisableEnableControl('activity3Net', true);
    this.DisableEnableControl('activity4Net', true);
    this.DisableEnableControl('activity5Net', true);
  }

  //Validate & Save -
  ValidateAndSaveForm2() {
    this.formSubmitted = true;
    this.ClearMsgFields();
   
    if (this.dTVA == null || this.dTVA == undefined ) {
      this.msgErrorFieldMissing = true;
      return false;
    }

    this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
      if (element.Genre == 'I') {
        element.NoDeclaration = this.selectedDeclarationNo;
      }
    });
    this.dTVA = (this.dTVA===0 || this.dTVA === '0') ? this.dTVA  : this.conversionCommaToDot(this.dTVA);
    this.activity1Model.Net = (this.activity1Model.Net===0 || this.activity1Model.Net === null) ?this.activity1Model.Net : this.conversionCommaToDot(this.activity1Model.Net);
    this.activity2Model.Net = (this.activity2Model.Net===0 || this.activity2Model.Net === null) ? this.activity2Model.Net : this.conversionCommaToDot(this.activity2Model.Net);
    this.activity3Model.Net = (this.activity3Model.Net===0 || this.activity3Model.Net === null) ? this.activity3Model.Net : this.conversionCommaToDot(this.activity3Model.Net);
    this.activity4Model.Net = (this.activity4Model.Net===0 || this.activity4Model.Net === null) ? this.activity4Model.Net : this.conversionCommaToDot(this.activity4Model.Net);
    this.activity5Model.Net = (this.activity5Model.Net===0 || this.activity5Model.Net === null) ? this.activity5Model.Net : this.conversionCommaToDot(this.activity5Model.Net);

    this.percent1 = !this.isActivity1Present && this.activity1Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity1Model.Percentage);
    this.percent2 = !this.isActivity2Present && this.activity2Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity2Model.Percentage);
    this.percent3 = !this.isActivity3Present && this.activity3Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity3Model.Percentage);
    this.percent4 = !this.isActivity4Present && this.activity4Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity4Model.Percentage);
    this.percent5 = !this.isActivity5Present && this.activity5Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity5Model.Percentage);

    this.totalPercentage = this.percent1 + this.percent2 + this.percent3 + this.percent4 + this.percent5;

    if (this.totalPercentage !== 0) {
      if (this.totalPercentage > 100 || this.totalPercentage < 100) {
        this.msgErrorPercent = true;
        this.msgErrorFieldMissing = false;
        return false;
      }
      else {
        this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo) {
            element.CodePourcentTot = 100;
          }
        });
      }
    }

    if (this.percent1 > 0 || this.percent2 > 0 || this.percent3 > 0 || this.percent4 > 0 || this.percent5 > 0) {
      if (this.isActivity1Present) {
        if (this.activity1Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[0].Libelle = this.activity1Model.Label == undefined ? '' : this.activity1Model.Label;
              element.Activite[0].Pourcent = this.conversionCommaToDot(this.activity1Model.Percentage);
              element.Activite[0].CodeActivite = this.activity1Model.ActivityNo;
              element.Activite[0].CodeRepartition = 'IREPPOURC';
              element.Activite[0].CodeMontantBrut = "IFACTTOT";
              element.Activite[0].CodeMontantNet = "IFACTNET";
              element.Activite[0].MontantNet = 0;
              element.Activite[0].MontantBrut = 0;
            }
          });
        }
      }
      if (this.isActivity2Present) {
        if (this.activity2Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[1].Libelle = this.activity2Model.Label == undefined ? '' : this.activity2Model.Label;
              element.Activite[1].Pourcent = this.conversionCommaToDot(this.activity2Model.Percentage);
              element.Activite[1].CodeActivite = this.activity2Model.ActivityNo;
              element.Activite[1].CodeRepartition = 'IREPPOURC';
              element.Activite[1].CodeMontantBrut = "IFACTTOT";
              element.Activite[1].CodeMontantNet = "IFACTNET";
              element.Activite[1].MontantNet = 0;
              element.Activite[1].MontantBrut = 0;
            }
          });
        }
      }
      if (this.isActivity3Present) {
        if (this.activity3Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[2].Libelle = this.activity3Model.Label == undefined ? '' : this.activity3Model.Label;
              element.Activite[2].Pourcent = this.conversionCommaToDot(this.activity3Model.Percentage);
              element.Activite[2].CodeActivite = this.activity3Model.ActivityNo;
              element.Activite[2].CodeRepartition = 'IREPPOURC';
              element.Activite[2].CodeMontantBrut = "IFACTTOT";
              element.Activite[2].CodeMontantNet = "IFACTNET";
              element.Activite[2].MontantNet = 0;
              element.Activite[2].MontantBrut = 0;
            }
          });
        }
      }
      if (this.isActivity4Present) {
        if (this.activity4Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[3].Libelle = this.activity4Model.Label == undefined ? '' : this.activity4Model.Label;
              element.Activite[3].Pourcent = this.conversionCommaToDot(this.activity4Model.Percentage);
              element.Activite[3].CodeActivite = this.activity4Model.ActivityNo;
              element.Activite[3].CodeRepartition = 'IREPPOURC';
              element.Activite[3].CodeMontantBrut = "IFACTTOT";
              element.Activite[3].CodeMontantNet = "IFACTNET";
              element.Activite[3].MontantNet = 0;
              element.Activite[3].MontantBrut = 0;
            }
          });
        }
      }
      if (this.isActivity5Present) {
        if (this.activity5Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[4].Libelle = this.activity5Model.Label == undefined ? '' : this.activity5Model.Label;
              element.Activite[4].Pourcent = this.conversionCommaToDot(this.activity5Model.Percentage);
              element.Activite[4].CodeActivite = this.activity5Model.ActivityNo;
              element.Activite[4].CodeRepartition = 'IREPPOURC';
              element.Activite[4].CodeMontantBrut = "IFACTTOT";
              element.Activite[4].CodeMontantNet = "IFACTNET";
              element.Activite[4].MontantNet = 0;
              element.Activite[4].MontantBrut = 0;
            }
          });
        }
      }
      this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.MontantTVA = this.dTVA;
          element.Statut = "ACTIVE";
        }
      });

      this.msgErrorPercent = false;
      this.msgErrorNET = false;
      this.msgErrorNotSaved = false;
      this.PrepareFormRootData();
      this.PrepareHeaderData();
      this.PrepareDeclarationData();
      this.DeleteUnavailableActivity();

      if (this.FormsData !== null) {
        this.FormsData.forEach(element => {
          if (element.Genre == "I" && element.NoDeclaration == this.selectedDeclarationNo) {
            element.MontantNet = this.conversionCommaToDot(this.dTVA);
            element.MontantTVA = 0;
            element.MontantBrut = this.dTVA;
            element.CodePourcentTot = 100;
            element.CodeMontantBrut = "IFACTTTOT";
            element.CodeMontantNet = "IFACTTNET";
            element.CodeMontantTVA = "IFACTTTVA";
            element.LastModifiedDate = formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100');
            element.PeriodeDebut = element.PeriodeDebut == null ? "" : (element.PeriodeDebut.length == 10 ? element.PeriodeDebut : this.customDateFormat(element.PeriodeDebut));
            element.PeriodeFin = element.PeriodeFin == null ? "" : (element.PeriodeFin.length == 10 ? element.PeriodeFin : this.customDateFormat(element.PeriodeFin));
            element.Exercice = parseInt(sessionStorage.getItem("Year"));
            element.Statut = "ACTIVE";
            element.Comment = this.remarks;
            var activite = [];
            this.declaration2Data.dataXML.XMLFile.Declaration.forEach(item => {
              if (item.Genre == 'I' && item.NoDeclaration == this.selectedDeclarationNo) {
                item.Activite.forEach(e => {
                  if(activite.filter(u => u.CodeActivite === e.CodeActivite).length == 0)
                  {
                    activite.push(e);
                  }
                });
              }
            });
            element.Activite = activite;
          }
          else {
            this.declaration2Data.dataXML.XMLFile.Declaration.push(element);
          }
        });
      }

      this.declaration2Data.dataXML.XMLFile.Declaration = this.FormsData;
      this.SavedData = this.declaration2Data;
      var JsonForm2SaveDeclaration = JSON.stringify(this.SavedData);
      this.Declaration2Data = JSON.parse(JsonForm2SaveDeclaration);
      //Percentages Save -
      this.service.SaveDeclaration1(this.Declaration2Data).subscribe(
        (data) => {
          if (data == 'Failed') {
            this.msgErrorNotSaved = true;
            sessionStorage.setItem('isForm2Saved', 'false');
          }
          else {
            sessionStorage.setItem("FormsData", JSON.stringify(this.FormsData));
            sessionStorage.setItem("AllDeclarationData", JsonForm2SaveDeclaration);
            sessionStorage.setItem("SavedDeclaration2CachedData", JsonForm2SaveDeclaration);
            this.getCurrentDate();
            sessionStorage.setItem('isForm2Saved', 'true');
            this.gotoDashboard();
          }
        },
        (err) => {
          this.msgErrorNotSaved = true;
        });
    }
    else { //NET TVA Value Check

      if (this.isActivity1Present && this.isActivity2Present) { // 1
        if (this.activity1Model.Net == undefined || this.activity1Model.Net == null) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null && element.Activite.length > 0) {
            element.Activite[0].CodeActivite = this.activity1Model.ActivityNo;
            element.Activite[0].Libelle = this.activity1Model.Label == undefined ? '' : this.activity1Model.Label;
            element.Activite[0].MontantNet = this.activity1Model.Net;
            element.Activite[0].MontantBrut = this.activity1Model.Net;
            element.Activite[0].CodeMontantBrut = "IFACTTOT";
            element.Activite[0].CodeMontantNet = "IFACTNET";
            element.Activite[0].Pourcent = 0;
          }
        });
      }
      else { //IF there is 1 Activity,Push the Contrat info to Activity 1 -
        this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null && element.Activite.length > 0) {
            element.Activite[0].CodeActivite = this.activity1Model.ActivityNo;
            element.Activite[0].Libelle = this.activity1Model.Label == undefined ? '' : this.activity1Model.Label;
            element.Activite[0].MontantNet = 0;
            element.Activite[0].TVAApplicable = this.activity1Model.TVAApplicable ? 1 : 0;
            element.Activite[0].MontantBrut = 0;
            element.Activite[0].CodeMontantBrut = "IFACTTOT";
            element.Activite[0].CodeMontantNet = "IFACTNET";
          }
        });
      }
      if (this.isActivity2Present) { //2
        if (this.activity2Model.Net == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null && element.Activite.length > 0 && element.Activite[1] !== null) {
            element.Activite[1].CodeActivite = this.activity2Model.ActivityNo;
            element.Activite[1].Libelle = this.activity2Model.Label == undefined ? '' : this.activity2Model.Label;
            element.Activite[1].MontantNet = this.activity2Model.Net;
            element.Activite[1].MontantBrut = this.activity2Model.Net;
            element.Activite[1].CodeMontantBrut = "IFACTTOT";
            element.Activite[1].CodeMontantNet = "IFACTNET";
            element.Activite[1].Pourcent = 0;
          }
        });
      }
      if (this.isActivity3Present) { //3
        if (this.activity3Model.Net == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null  && element.Activite.length > 0) {
            element.Activite[2].CodeActivite = this.activity3Model.ActivityNo;
            element.Activite[2].Libelle = this.activity3Model.Label == undefined ? '' : this.activity3Model.Label;
            element.Activite[2].MontantNet = this.activity3Model.Net;
            element.Activite[2].MontantBrut = this.activity3Model.Net;
            element.Activite[2].CodeMontantBrut = "IFACTTOT";
            element.Activite[2].CodeMontantNet = "IFACTNET";
            element.Activite[2].Pourcent = 0;
          }
        });
      }
      if (this.isActivity4Present) { //4
        if (this.activity4Model.Net == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null && element.Activite.length > 0) {
            element.Activite[3].CodeActivite = this.activity4Model.ActivityNo;
            element.Activite[3].Libelle = this.activity4Model.Label == undefined ? '' : this.activity4Model.Label;
            element.Activite[3].MontantNet = this.activity4Model.Net;
            element.Activite[3].MontantBrut = this.activity4Model.Net;
            element.Activite[3].CodeMontantBrut = "IFACTTOT";
            element.Activite[3].CodeMontantNet = "IFACTNET";
            element.Activite[3].Pourcent = 0;
          }
        });
      }
      if (this.isActivity5Present) { //5
        if (this.activity5Model.Net == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null && element.Activite.length > 0) {
            element.Activite[4].CodeActivite = this.activity5Model.ActivityNo;
            element.Activite[4].Libelle = this.activity5Model.Label == undefined ? '' : this.activity5Model.Label;
            element.Activite[4].MontantNet = this.activity5Model.Net;
            element.Activite[4].MontantBrut = this.activity5Model.Net;
            element.Activite[4].CodeMontantBrut = "IFACTTOT";
            element.Activite[4].CodeMontantNet = "IFACTNET";
            element.Activite[4].Pourcent = 0;
          }
        });
      }
      this.a1NET = !this.isActivity1Present && this.activity1Model.Net == undefined ? 0 : this.conversionCommaToDot(this.activity1Model.Net);
      this.a2NET = !this.isActivity2Present && this.activity2Model.Net == undefined ? 0 : this.conversionCommaToDot(this.activity2Model.Net);
      this.a3NET = !this.isActivity3Present && this.activity3Model.Net == undefined ? 0 : this.conversionCommaToDot(this.activity3Model.Net);
      this.a4NET = !this.isActivity4Present && this.activity4Model.Net == undefined ? 0 : this.conversionCommaToDot(this.activity4Model.Net);
      this.a5NET = !this.isActivity5Present && this.activity5Model.Net == undefined ? 0 : this.conversionCommaToDot(this.activity5Model.Net);
      this.sumOfActivityNetAmt = this.a1NET + this.a2NET + this.a3NET + this.a4NET + this.a5NET;
      this.sumOfActivityNetAmt = Number(this.sumOfActivityNetAmt.toFixed(2));
      if (this.isActivity1Present &&
        (this.isActivity2Present || this.isActivity3Present || this.isActivity4Present || this.isActivity5Present)) {
          
          if (this.sumOfActivityNetAmt != this.dTVA) {
            this.dTVA =  this.formatPipe.transform(this.dTVA);
          this.msgErrorNET = true;
          this.msgErrorPercent = false;
          this.msgErrorFieldMissing = false;
          return false;
        }
      }
      // this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
      //   if (element.Genre == 'I') {
      //     element.MontantTVA = this.dTVA;
      //     element.CodePourcentTot = 0;
      //     element.Statut = "ACTIVE";
      //   }
      // });
      this.PrepareFormRootData();
      this.PrepareHeaderData();
      this.PrepareDeclarationData();
      this.DeleteUnavailableActivity();

      if (this.FormsData !== null) {
        this.FormsData.forEach(element => {
          if (element.Genre == "I" && element.NoDeclaration == this.selectedDeclarationNo) {
            element.MontantNet = this.conversionCommaToDot(this.dTVA);
            element.MontantTVA = 0;
            element.MontantBrut = this.dTVA;
            element.CodePourcentTot = 0;
            element.CodeMontantBrut = "IFACTTTOT";
            element.CodeMontantNet = "IFACTTNET";
            element.CodeMontantTVA = "IFACTTTVA";
            element.Statut = "ACTIVE";
            element.LastModifiedDate = formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100');
            element.PeriodeDebut = element.PeriodeDebut == null ? "" : (element.PeriodeDebut.length == 10 ? element.PeriodeDebut : this.customDateFormat(element.PeriodeDebut));
            element.PeriodeFin = element.PeriodeFin == null ? "" : (element.PeriodeFin.length == 10 ? element.PeriodeFin : this.customDateFormat(element.PeriodeFin));
            element.Exercice = parseInt(sessionStorage.getItem("Year"));
            element.Comment = this.remarks;
            var activite = [];
            this.declaration2Data.dataXML.XMLFile.Declaration.forEach(item => {
              if (item.Genre == 'I' && item.NoDeclaration == this.selectedDeclarationNo) {
                item.Activite.forEach(e => {
                  if(activite.filter(u => u.CodeActivite === e.CodeActivite).length == 0)
                  {
                    activite.push(e);
                  }
                });
              }
            });
            element.Activite = activite;
          }
          else {
            this.declaration2Data.dataXML.XMLFile.Declaration.push(element);
          }
        });
      }
      this.declaration2Data.dataXML.XMLFile.Declaration = this.FormsData;
      this.SavedData = this.declaration2Data;
      var JsonForm2SaveDeclaration = JSON.stringify(this.SavedData);
      this.Declaration2Data = JSON.parse(JsonForm2SaveDeclaration);

      this.service.SaveDeclaration1(this.Declaration2Data).subscribe(
        (data) => {
          if (data == 'Failed') {
            this.msgErrorNotSaved = true;
            sessionStorage.setItem('isForm2Saved', 'false');
          }
          else {
            sessionStorage.setItem("FormsData", JSON.stringify(this.FormsData));
            sessionStorage.setItem("AllDeclarationData", JsonForm2SaveDeclaration);
            sessionStorage.setItem("SavedDeclaration2CachedData", JsonForm2SaveDeclaration);
            sessionStorage.setItem('isForm2Saved', 'true');
            this.getCurrentDate();
            this.gotoDashboard();
          }
        },
        (err) => {
          this.msgErrorNotSaved = true;
        });
    }

  }
  ClearMsgFields() {
    this.msgErrorPercent = false; // if percentages does not 100%
    this.msgErrorNET = false; // if the Net ammount is not equal to actvities net amount
    this.msgErrorNotSaved = false;
    this.msgErrorFieldMissing = false;//mandatory field missing
    this.msgMaxPercentageError = false;
  }
  ngOnDestroy(): void {
    sessionStorage.removeItem("selectedFormData");
    this.declaration2Data.dataXML.XMLFile.Declaration =
      [
        {
          Comment: "",
          contrat: [],
          Exercice: 0,
          PeriodeDebut: '',
          PeriodeFin: '',
          NoDeclaration: 0,
          NoProgressif: 0,
          Genre: "",
          noIntervenantDestinataire: 0,
          NomDestinataire: "",
          PrenomDestinataire: "",
          RoleDestinataire: "",
          Statut: "",
          Libelle: "",
          CodeMontantBrut: "",
          MontantBrut: 0,
          CodeMontantNet: '',
          MontantNet: 0,
          CodeMontantTVA: '',
          MontantTVA: 0,
          TVAApplicable: 1,
          CodeActivite: "",
          Activite: [
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "ZCHAFTTOT",
              CodeMontantNet: "ZCHAFTNET",
              CodeMontantTVA: "ZFACTTTVA",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "ZCHAFTTOT",
              CodeMontantNet: "ZCHAFTNET",
              CodeMontantTVA: "ZFACTTTVA",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "ZCHAFTTOT",
              CodeMontantNet: "ZCHAFTNET",
              CodeMontantTVA: "ZFACTTTVA",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "ZCHAFTTOT",
              CodeMontantNet: "ZCHAFTNET",
              CodeMontantTVA: "ZFACTTTVA",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "ZCHAFTTOT",
              CodeMontantNet: "ZCHAFTNET",
              CodeMontantTVA: "ZFACTTTVA",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
          ],
          LastModifiedDate: "",
          CodePourcentTot: 0,
          independant: [

          ]
        }
      ];
    this.activitiesCollection = [];
  }

  gotoDashboard() {
    this._router.navigate(['/dashboard']);
  }
  getCurrentDate() {
    sessionStorage.setItem('form2SubmittedDate', formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100'));
  }

  remarksEntered() {
    if (this.remarks !== null && this.remarks !== undefined) {
      this.isDataEntered = true;
    }
  }


  PrepareDeclarationData() {
    this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
      if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo) {
        element.Comment = this.Form2.get("remarks").value;
        element.Genre = 'I';
        element.Exercice = parseInt(sessionStorage.getItem("Year"));
        element.noIntervenantDestinataire = this.form2Data.NoIntervenantDestinataire;
        element.RoleDestinataire = this.form2Data.RoleDestinataire;
        element.NoDeclaration = this.form2Data.NoDeclaration;
        element.NomDestinataire = this.form2Data.NomDestinataire;
        element.NoProgressif = this.form2Data.NoProgressif;
        element.RoleDestinataire = this.form2Data.RoleDestinataire;
        element.CodeMontantBrut = 'IFACTTTOT';
        element.CodeMontantNet = 'IFACTTNET';
        element.CodeMontantTVA = 'IFACTTTVA';
        element.MontantBrut = this.dTVA;
      }
    });
  }
  customDateFormat(date) {
    if (date !== '' && date !== null) {
      if (date.length == 19) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.substring(10, 8);
        return [day, month, year].join('/');
      } else if (date.length == 8) {
        var year = date.substring(0, 4);
        var month = date.substring(6, 4);
        var day = date.slice(date.length - 2);
        return [day, month, year].join('/');
      } else if (date.length == 10) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.slice(date.length - 2);
        return [day, month, year].join('/');
      } else {
        return null;
      }
    }
  }
  PrepareHeaderData() {
    this.declaration2Data.dataXML.XMLFile.Header.NoClient = parseInt(sessionStorage.getItem('ClientNo'));
    this.declaration2Data.dataXML.XMLFile.Header.Email = sessionStorage.getItem('NewEmail') != null ? sessionStorage.getItem('NewEmail') : sessionStorage.getItem('Email');
    this.declaration2Data.dataXML.XMLFile.Header.CodePostal = this.clientsData.CodePostal;
    this.declaration2Data.dataXML.XMLFile.Header.LibellePays = this.clientsData.LibellePays;
    this.declaration2Data.dataXML.XMLFile.Header.Localite = this.clientsData.Localite;
    this.declaration2Data.dataXML.XMLFile.Header.Rue = this.clientsData.Rue;
    this.declaration2Data.dataXML.XMLFile.Header.NoRue = this.clientsData.NoRue;
    this.declaration2Data.dataXML.XMLFile.Header.QualCiv = this.clientsData.QualCiv;
    this.declaration2Data.dataXML.XMLFile.Header.RegimeLinguistique = sessionStorage.getItem("currentlang") === 'FR' ? 1 : 2;
    this.declaration2Data.dataXML.XMLFile.Header.Nom = this.clientsData.Nom;
    this.declaration2Data.dataXML.XMLFile.Header.Prenom = this.clientsData.Prenom;
    
  }

  PrepareFormRootData() {
    this.declaration2Data.FormType = 'DECL_ON_2020';
    this.declaration2Data.FormSubType = 'FORM';
    this.declaration2Data.ContractNummer = '';
    this.declaration2Data.AccountNumber = sessionStorage.getItem('ClientNo');
    this.declaration2Data.User = 0; //yet to get from -  RetrieveDeclarationParClient
  }
  DisablePercentageControlls() {
    this.DisableEnableControl('activity1Percent', false);
    this.DisableEnableControl('activity2Percent', false);
    this.DisableEnableControl('activity3Percent', false);
    this.DisableEnableControl('activity4Percent', false);
    this.DisableEnableControl('activity5Percent', false);
  }
  DisableNETControlls() {
    this.DisableEnableControl('activity1Net', false);
    this.DisableEnableControl('activity2Net', false);
    this.DisableEnableControl('activity3Net', false);
    this.DisableEnableControl('activity4Net', false);
    this.DisableEnableControl('activity5Net', false);
  }
  DeleteUnavailableActivity() {
    if (!this.isActivity2Present)
      this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite.splice(1);
        }
      });
    if (!this.isActivity3Present)
      this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite.splice(2);
        }
      });
    if (!this.isActivity4Present)
      this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite.splice(3);
        }
      });
    if (!this.isActivity5Present)
      this.declaration2Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'I' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite.splice(4);
        }
      });
  }
  EnablePercentageControlls() {
    this.DisableEnableControl('activity1Percent', true);
    this.DisableEnableControl('activity2Percent', true);
    this.DisableEnableControl('activity3Percent', true);
    this.DisableEnableControl('activity4Percent', true);
    this.DisableEnableControl('activity5Percent', true);
  }

}


